import { Head } from '@inertiajs/react';
import { CronJobsCard } from '@/components/cron/cron-jobs-card';
import type { AdminCronJobsIndex } from '@/types';

export default function Index({
  title,
  scheduledJobs,
  oneOffJobs,
}: AdminCronJobsIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Cron Jobs</h1>
          <p className="text-muted-foreground">
            Global jobs not tied to any event. Event-scoped jobs live under each
            event's Cron Jobs page.
          </p>
        </div>

        <CronJobsCard
          title="Scheduled Jobs"
          description="Jobs are checked every 3 seconds by the production cron ticker service"
          jobs={scheduledJobs}
          emptyMessage="No scheduled jobs configured"
        />

        <CronJobsCard
          title="One-Off Actions"
          description="Manual actions that can be triggered on-demand"
          jobs={oneOffJobs}
          emptyMessage="No one-off actions configured"
        />
      </div>
    </>
  );
}
